import { isNumber } from "~/tools/is-number";

import { isDate } from "./_date-fns";

export type Time = number | Date;

export function isTime(input: unknown): input is Time {
	return isNumber(input) || isDate(input);
}
